/* ============================================================
   BEXFORD — Cart drawer + Quick view
   ============================================================ */
(function () {
  var settings = window.bexfordCartSettings || { enableCartDrawer: true, emptyMessage: 'Your cart is empty.', showFreeShippingBar: false, freeShippingThreshold: 15000 };
  var overlay = document.getElementById('side-drawer-overlay');
  var cartDrawer = document.getElementById('cart-drawer');
  var cartBody = document.getElementById('cart-drawer-body');
  var cartCount = document.getElementById('cart-drawer-count');
  var cartSubtotal = document.getElementById('cart-drawer-subtotal');
  var shippingBar = document.getElementById('cart-drawer-shipping-bar');
  var qvDrawer = document.getElementById('quickview-drawer');
  var qvBody = document.getElementById('quickview-drawer-body');

  if (!overlay || !cartDrawer || !qvDrawer) return;

  function money(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'USD' });
  }

  /* After a successful add: open the drawer if enabled, otherwise send them to the real cart page */
  function showCartAfterAdd() {
    if (settings.enableCartDrawer) {
      openDrawer(cartDrawer);
    } else {
      window.location.href = '/cart';
    }
  }

  function openDrawer(drawer) {
    document.querySelectorAll('.side-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawers() {
    document.querySelectorAll('.side-drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  overlay.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawers();
  });
  document.getElementById('cart-drawer-close').addEventListener('click', closeDrawers);
  document.getElementById('quickview-drawer-close').addEventListener('click', closeDrawers);

  /* ── Cart rendering ─────────────────────────────────────── */
  function renderCart(cart) {
    cartCount.textContent = cart.item_count;
    cartSubtotal.textContent = money(cart.total_price);
    var badge = document.querySelector('[data-cart-count-badge]');
    if (badge) badge.textContent = cart.item_count;

    if (shippingBar && settings.showFreeShippingBar) {
      var threshold = settings.freeShippingThreshold;
      var remaining = threshold - cart.total_price;
      if (remaining <= 0) {
        shippingBar.innerHTML = '<p class="cart-shipping-bar-text">You\'ve qualified for free shipping.</p><div class="cart-shipping-bar-track"><div class="cart-shipping-bar-fill" style="width:100%"></div></div>';
      } else {
        var pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
        shippingBar.innerHTML = '<p class="cart-shipping-bar-text">Add ' + money(remaining) + ' more for free shipping.</p><div class="cart-shipping-bar-track"><div class="cart-shipping-bar-fill" style="width:' + pct + '%"></div></div>';
      }
    }

    if (cart.item_count === 0) {
      cartBody.innerHTML = '<div class="side-drawer-empty"><p>' + settings.emptyMessage + '</p><a href="/collections/all" class="btn btn-dark">Shop the Collection</a></div>';
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var imgSrc = item.image ? item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_180x180$1$2') : '';
      var preorderNote = item.properties && item.properties['Pre-order'];
      html += '' +
        '<div class="cart-row" data-line-key="' + item.key + '">' +
          '<img src="' + imgSrc + '" alt="' + item.title.replace(/"/g, '&quot;') + '">' +
          '<div>' +
            '<div class="cart-row-title">' + item.product_title + '</div>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-row-variant">' + item.variant_title + '</div>' : '') +
            (preorderNote ? '<span class="product-badge preorder cart-preorder-badge">Preorder</span>' : '') +
            '<div class="cart-qty-controls">' +
              '<button type="button" class="cart-qty-btn" data-qty-change="-1">&minus;</button>' +
              '<span class="cart-qty-value">' + item.quantity + '</span>' +
              '<button type="button" class="cart-qty-btn" data-qty-change="1">+</button>' +
            '</div>' +
            '<button type="button" class="cart-row-remove" data-remove>Remove</button>' +
          '</div>' +
          '<div class="cart-row-price">' + money(item.final_line_price) + '</div>' +
        '</div>';
    });
    cartBody.innerHTML = html;
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(function (data) {
      /* Shopify returns {status, message, description} instead of a cart object
         when a change fails (e.g. requesting more than available stock). */
      if (data.status) {
        alert(data.description || data.message || 'That quantity isn\'t available.');
        return fetchCart(); // re-sync the drawer to the real, unchanged cart state
      }
      renderCart(data);
    });
  }

  cartBody.addEventListener('click', function (e) {
    var row = e.target.closest('.cart-row');
    if (!row) return;
    var key = row.dataset.lineKey;
    var qtyEl = row.querySelector('.cart-qty-value');
    var qty = parseInt(qtyEl.textContent, 10);

    if (e.target.matches('[data-qty-change]')) {
      var delta = parseInt(e.target.dataset.qtyChange, 10);
      changeLine(key, Math.max(0, qty + delta));
    }
    if (e.target.matches('[data-remove]')) {
      changeLine(key, 0);
    }
  });

  /* ── Add to cart (shared by quick-add + quick view) ────────── */
  function addToCart(variantId, qty, properties) {
    var body = { id: variantId, quantity: qty || 1 };
    if (properties) body.properties = properties;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    });
  }

  function quickAdd(button) {
    var card = button.closest('[data-variant-id]');
    if (!card) return;
    var variantId = card.dataset.variantId;
    var properties = card.dataset.preorderActive === 'true' ? { 'Pre-order': card.dataset.preorderShipWindow || 'Ships once available' } : null;
    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    addToCart(variantId, 1, properties)
      .then(function () { return fetchCart(); })
      .then(function () {
        button.textContent = 'Added ✓';
        showCartAfterAdd();
        setTimeout(function () {
          button.disabled = false;
          button.textContent = originalText;
        }, 1500);
      })
      .catch(function () {
        button.textContent = 'Error';
        setTimeout(function () {
          button.disabled = false;
          button.textContent = originalText;
        }, 1500);
      });
  }

  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('.js-quick-add');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (!addBtn.disabled) quickAdd(addBtn);
      return;
    }
    var qvBtn = e.target.closest('.js-quick-view');
    if (qvBtn) {
      e.preventDefault();
      e.stopPropagation();
      var card = qvBtn.closest('[data-product-url]');
      if (card) openQuickView(card.dataset.productUrl, card.dataset.displayTitle, card.dataset.preorderActive === 'true', card.dataset.preorderShipWindow);
      return;
    }
  });

  /* ── Header cart icon opens the drawer instead of navigating ─ */
  var cartLink = document.querySelector('[data-cart-icon-link]');
  if (cartLink) {
    cartLink.addEventListener('click', function (e) {
      e.preventDefault();
      fetchCart();
      openDrawer(cartDrawer);
    });
  }

  /* Populate cart drawer + badge with real numbers on every page load */
  fetchCart();

  /* ── Quick view ─────────────────────────────────────────── */
  function openQuickView(productUrl, displayTitle, preorderActive, preorderShipWindow) {
    qvBody.innerHTML = '<div class="qv-loading">Loading…</div>';
    openDrawer(qvDrawer);

    fetch(productUrl + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        renderQuickView(product, displayTitle, preorderActive, preorderShipWindow);
      })
      .catch(function () {
        qvBody.innerHTML = '<div class="qv-loading">Couldn\'t load this product.</div>';
      });
  }

  function renderQuickView(product, displayTitle, preorderActive, preorderShipWindow) {
    var titleToShow = displayTitle || product.title;
    var variant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
    var image = variant.featured_image ? variant.featured_image.src : (product.featured_image || product.images[0]);
    var hasOptions = product.variants.length > 1;

    var optionsHtml = '';
    if (hasOptions) {
      product.options.forEach(function (option, i) {
        var optionName = (option && option.name) ? option.name : option;
        var values = [];
        product.variants.forEach(function (v) {
          var val = v.options[i];
          if (values.indexOf(val) === -1) values.push(val);
        });
        optionsHtml += '<div class="form-group"><label class="form-label">' + optionName + '</label>' +
          '<select class="form-control qv-option-select" data-option-index="' + i + '">' +
          values.map(function (v) {
            var selected = v === variant.options[i] ? ' selected' : '';
            return '<option value="' + v.replace(/"/g, '&quot;') + '"' + selected + '>' + v + '</option>';
          }).join('') +
          '</select></div>';
      });
    }

    function withWidth(src, w) {
      var sep = src.indexOf('?') > -1 ? '&' : '?';
      return src + sep + 'width=' + w;
    }

    var thumbsHtml = '';
    if (product.images.length > 1) {
      thumbsHtml = '<div class="qv-thumbs">' +
        product.images.map(function (imgSrc, i) {
          var active = imgSrc === image ? ' active' : '';
          return '<div class="qv-thumb' + active + '" data-src="' + imgSrc + '"><img src="' + withWidth(imgSrc, 160) + '" alt=""></div>';
        }).join('') +
        '</div>';
    }

    var ribbonHtml = preorderActive ? '<div class="pdp-preorder-ribbon">Preorder</div>' : '';
    var addLabel = variant.available ? (preorderActive ? 'Pre-order' : 'Add to Cart') : 'Sold Out';

    qvBody.innerHTML = '' +
      '<div class="qv-image">' + ribbonHtml + '<img src="' + withWidth(image, 800) + '" id="qv-main-image" alt="' + titleToShow.replace(/"/g, '&quot;') + '"></div>' +
      thumbsHtml +
      '<span class="qv-series-tag">' + (product.type || '') + '</span>' +
      '<h2 class="qv-title">' + titleToShow + '</h2>' +
      '<div class="qv-price" id="qv-price">' + money(variant.price) + '</div>' +
      (preorderActive ? '<p class="pdp-avail-note">Pre-order' + (preorderShipWindow ? ' &nbsp;·&nbsp; ' + preorderShipWindow : '') + '</p>' : '') +
      '<div id="qv-options">' + optionsHtml + '</div>' +
      '<div class="pdp-actions" style="margin-top:1.25rem;">' +
        '<button type="button" class="btn-add-cart" id="qv-add-cart"' + (variant.available ? '' : ' disabled') + '>' +
          addLabel +
        '</button>' +
        '<a href="' + product.url + '" class="btn-inquire">Full Details</a>' +
      '</div>';

    var currentVariant = variant;
    var addBtn = document.getElementById('qv-add-cart');
    var priceEl = document.getElementById('qv-price');
    var mainImageEl = document.getElementById('qv-main-image');

    function setActiveThumb(src) {
      qvBody.querySelectorAll('.qv-thumb').forEach(function (t) {
        t.classList.toggle('active', t.dataset.src === src);
      });
    }

    qvBody.querySelectorAll('.qv-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImageEl.src = withWidth(thumb.dataset.src, 800);
        setActiveThumb(thumb.dataset.src);
      });
    });

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      });
    }

    var selects = qvBody.querySelectorAll('.qv-option-select');
    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        var opts = Array.prototype.map.call(selects, function (s) { return s.value; });
        var match = findVariant(opts);
        if (!match) return;
        currentVariant = match;
        priceEl.textContent = money(match.price);
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? (preorderActive ? 'Pre-order' : 'Add to Cart') : 'Sold Out';

        /* Swap the main image (and matching thumb) to this variant's photo, if it has one */
        if (match.featured_image && match.featured_image.src) {
          mainImageEl.src = withWidth(match.featured_image.src, 800);
          setActiveThumb(match.featured_image.src);
        }
      });
    });

    addBtn.addEventListener('click', function () {
      if (addBtn.disabled) return;
      var originalText = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      var properties = preorderActive ? { 'Pre-order': preorderShipWindow || 'Ships once available' } : null;
      addToCart(currentVariant.id, 1, properties)
        .then(function () { return fetchCart(); })
        .then(function () {
          showCartAfterAdd();
        })
        .catch(function () {
          addBtn.textContent = 'Error';
          setTimeout(function () {
            addBtn.disabled = false;
            addBtn.textContent = originalText;
          }, 1500);
        });
    });
  }

  /* ── Public API — lets other scripts (e.g. the PDP) reuse this cart flow ── */
  window.BexfordCart = {
    addToCart: addToCart,
    fetchCart: fetchCart,
    openCart: function () { openDrawer(cartDrawer); },
    showCartAfterAdd: showCartAfterAdd,
    openQuickView: openQuickView
  };
})();
